<button
    class="w-full inline-flex items-center justify-center"
    [ngClass]="buttonClasses"
    [ngStyle]="buttonStyle"
    *ngIf="!job?.enableCustomApplyURL && component?.['showApplyButton'] !== false"
    (click)="apply()" i18n>
    <span class="mat-icon" *ngIf="buttonConfig?.icon">{{ buttonConfig.icon }}</span>
    {{ job?.active ? "Apply Now" : "Register Interest" }}
</button>
<a
    class="w-full inline-flex items-center justify-center"
    [ngClass]="buttonClasses"
    [ngStyle]="buttonStyle"
    target="_blank"
    [href]="job?.customApplyURL"
    *ngIf="job?.enableCustomApplyURL && component?.['showApplyButton'] !== false"
    (click)="onThirdPartyApply()" i18n>
    <span class="mat-icon" *ngIf="buttonConfig?.icon">{{ buttonConfig.icon }}</span>
    Apply Now
</a>
